export type ProductTabKey =
  | 'general'
  | 'parts'
  | 'certificates'
  | 'inspections'
  | 'stockHistory';

export const PRODUCT_TABS: { key: ProductTabKey; label: string }[] = [
  { key: 'general', label: '일반' },
  { key: 'parts', label: '부품' },
  { key: 'certificates', label: '인증서' },
  { key: 'inspections', label: '검사이력' },
  { key: 'stockHistory', label: '재고이력' },
];

export const PRODUCT_TAB_PLACEHOLDERS: Record<
  Exclude<ProductTabKey, 'general' | 'stockHistory' | 'inspections'>,
  { title: string; description: string }
> = {
  parts: {
    title: '부품(BOM)',
    description:
      '구성 부품·수량·단가를 등록하는 화면입니다. 제품을 먼저 저장한 뒤 이용할 수 있습니다.',
  },
  certificates: {
    title: '인증서',
    description:
      '회사 인증서를 제품에 연결하는 화면입니다. 제품을 먼저 저장한 뒤 이용할 수 있습니다.',
  },
};
